




































































import Vue from "vue";
import { Component, Emit, Prop, Watch } from "vue-property-decorator";
import {post} from '../../services/webclient/webclient';
import "./popups.less";
import { translate } from "../../services/translation/translation";

@Component
export default class LoginPopup extends Vue {
  email: string = "";
  password: string = "";
  isVisible = false;
  FPassword = false;
  SuccessPWRec = false;
  backendMessage = '';
  recPWError = '';

  constructor() {
    super();
  }

  mounted() {
        let self=this;
      $(document).on('click toochstart','.calc-login',function(){
          self.isVisible = true;
          self.FPassword = false;
          self.SuccessPWRec = false;
      });
    //kell még bezáró x-is amin: @click="close()"
    //loginendpoint: /postLogin
        //válasz: ha redirectURL jön akkor sikeres volt a belépés
            //nem redirectelünk hanem megjelenítjük neki az űrlapot
    //pwresetendpoint: /passwordReset/findEmail
        //válasz: 'result' => 'success'  vagy : 'modalMessage' => '...'
  }

    trans(key) {
            return translate(key);
        }

  sendLogin(ok) {
      let self=this;
      post('/postLogin',{
        login_email: this.email,
        login_password: this.password
    }).then(res => {
        if(res.hasOwnProperty('redirectURL')){
            self.login(true);
            self.isVisible = false;
        }
        else{
            self.login(false);
            self.backendMessage = res.invalidCredentials;
        }
    });
    return false;
  }
  pwRecShow(){
      this.FPassword=true;
  }
  sendPWRec(ok) {
      let self = this;
    post('/passwordReset/findEmail',{
        recovery_email: this.email,
    }).then(res => {
        if(res.result=='success'){
            self.SuccessPWRec = true;
        }
        else{
            self.recPWError = res.modalMessage;
        }
    });
    return false;
  }

   close(){
      this.isVisible = false;
  }

  @Emit("login")
  login(loggedin) {}
}
